import * as icons from './icons/index';

interface IconAttributes {
  accent?: string;
  className?: string;
  fill?: string;
  height?: number;
  preserveAspectRatio?: string;
  primary?: string;
  width?: number;
}

export interface IconProps extends IconAttributes {
  icon: string;
}

const Icon = ({ icon, ...iconProps }: IconProps) => {
  if (!icon) return null;

  // @ts-ignore
  const Component = icons[icon];
  if (!Component) {
    // console.warn(`Missing icon: ${icon}`);
    return null;
  }
  return <Component {...iconProps} />;
};

export type IconType = typeof Icon;

export default Icon;
